import { render, staticRenderFns } from "./PayoutDetail.vue?vue&type=template&id=6d40a02e&scoped=true&"
import script from "./PayoutDetail.vue?vue&type=script&lang=js&"
export * from "./PayoutDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayoutDetail.vue?vue&type=style&index=0&id=6d40a02e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40a02e",
  null
  
)

export default component.exports